
import Vue from "vue";
import {
  notificationMapActions,
  notificationMapState
} from "@/store/modules/notification";

import { INotification } from "@/store/modules/notification/types";

interface IData {
  loading: boolean;
}

export default Vue.extend({
  name: "NotificationPreview",
  props: {
    maxNotifications: {
      type: Number,
      default: 3
    },
    excludeRoles: {
      type: Array as () => string[],
      default: () => ["Adjuster"]
    }
  },
  data(): IData {
    return {
      loading: false
    };
  },
  async mounted(): Promise<void> {
    if (this.$canReadNotifications) {
      await this.fetchNotifications();
    }
  },
  methods: {
    ...notificationMapActions(["getNotifications"]),
    async fetchNotifications(): Promise<void> {
      try {
        this.loading = true;
        const queryObject = {
          read: false, // Only get unread notifications
          __sort: "read,-modifiedOn",
          __limit: this.maxNotifications,
          userId: this.$getCurrentUser?._id
        };
        await this.getNotifications({ query: queryObject });
      } catch (error) {
        this.$bugSnagClient.notify(error);
      } finally {
        this.loading = false;
      }
    },
    displayNotificationMessage(message: string): string {
      return message.length >= 168 ? `${message.slice(0, 168)}...` : message;
    },
    goToViewAllNotifications(): void {
      if (this.$isCurrentUserAdmin) {
        this.$router.push("/admin/notifications").catch();
      } else {
        this.$router.push("/notifications").catch();
      }
    },
    goToNotification(id: string): void {
      const notificationRoute =
        this.$getCurrentUser.role === "admin"
          ? "/admin/notifications"
          : "/notifications";
      this.$router.push(`${notificationRoute}/${id}`).catch(() => {});
    },
    getIcon(priority: string): string {
      if (priority === "high") {
        return "arrow-up";
      } else if (priority === "medium") {
        return "arrows-h";
      } else {
        return "arrow-down";
      }
    },
    getIconClass(priority: string): string {
      if (priority === "high") {
        return "text-red-600";
      } else if (priority === "medium") {
        return "text-yellow-300";
      } else {
        return "text-green-600";
      }
    }
  },
  computed: {
    ...notificationMapState(["notifications"]),
    shouldShowNotifications(): boolean {
      const currentUserRole = this.$getCurrentUser?.role;
      return (
        this.$canReadNotifications &&
        !this.excludeRoles.includes(currentUserRole)
      );
    },
    displayNotifications(): INotification[] {
      return this.notifications.slice(0, this.maxNotifications);
    }
  }
});
